@if(isLoading) {
<kzn-loader [message]="'loaderGettingCustomers' | translate"></kzn-loader>
} @else if(isError) {
<kzn-status-message [message]="errorMessage"></kzn-status-message>
} @else {
<div class="customers-page">
  <div class="customers-page__header">
    @if (customerID) {
    <button
      mat-icon-button
      type="button"
      class="customers-page__back-btn"
      [matTooltip]="'back' | translate"
      (click)="navigateBackToList()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    }
    <div class="customers-page__header-icon">
      <mat-icon>supervisor_account</mat-icon>
    </div>
    <span class="customers-page__header-title">
      @if (customerID) {
        {{ selectedCustomer.CustomerName || ('customerDetailsTitle' | translate) }}
      } @else {
        {{ 'navCustomers' | translate }}
      }
    </span>
  </div>

  <div class="customers-page__panel">
    @if (customerID && selectedCustomer) {
    <kzn-view-customer
      (customerSubscriptionCreated)="onCustomerSubscriptionCreated()"
      (customerUpdated)="onCustomerUpdated()"
      [customerDetails]="selectedCustomer">
    </kzn-view-customer>
    } @else if (customerID) {
    <kzn-loader [message]="'loaderGettingCustomers' | translate"></kzn-loader>
    } @else {
    <div class="customers-page__filter-bar">
      <div class="customers-page__filter-fields">
        <div class="customers-page__filter-item customers-page__filter-item--search">
          <input
            id="customers-search"
            type="text"
            class="customers-page__search-input"
            [placeholder]="'searchPlaceholder' | translate"
            [(ngModel)]="tableSearchQuery"
            (keyup)="onTableSearch()" />
        </div>
      </div>

      <div class="customers-page__filter-actions">
        <button
          mat-icon-button
          type="button"
          color="primary"
          class="customers-page__btn-refresh"
          [matTooltip]="'refreshTableTooltip' | translate"
          (click)="getCustomers(true)">
          <mat-icon>refresh</mat-icon>
        </button>
        <button
          mat-flat-button
          type="button"
          color="primary"
          class="customers-page__btn-create"
          (click)="openCreateEditCustomerDialog()">
          <mat-icon>add</mat-icon>
          {{ 'createCustomer' | translate }}
        </button>
      </div>
    </div>

    <kzn-table
      #customersTable
      [data]="customers"
      [columns]="tableColumns"
      [rowActions]="tableRowActions"
      [defaultSortColumnDef]="defaultSortColumnDef"
      [defaultSortDirection]="defaultSortDirection"
      [showRefresh]="false"
      [showSearch]="false"
      actionColumnHeader="actions"
      style="width: 100%">
    </kzn-table>
    }
  </div>
</div>
}
